"use strict";

import React, {Component} from "react";
import PropTypes from "prop-types";

class Tabs extends Component {

    static defaultProps = {
        tabs: {},
    };

    static propTypes = {
        tabs: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            activeIdx: 0,
        }
    }

    render() {
        const { tabs } = this.props;

        return (
            <div className="nav-tabs-custom">
                <ul className="nav nav-tabs">
                    {this.renderTabs(tabs)}
                </ul>
                <div className="tab-content">
                    {this.renderTabPanels(tabs)}
                </div>
            </div>
        );
    }

    renderTabs(tabs) {

        let tabNodes = [];

        Object.keys(tabs || {}).forEach(tab => {
            let isActive = this.state.activeIdx === Object.keys(tabs || []).indexOf(tab);
            tabNodes.push(this.renderTab(tab, isActive));
        });

        return tabNodes;

    }

    renderTab(tab, isActive) {
        return (
            <li key={`${this.normalizeTabId(tab)}`} className={isActive ? 'active' : ''}><a href={`#${this.normalizeTabId(tab)}_content`} data-toggle="tab">{tab}</a></li>
        );
    }

    renderTabPanels(tabs) {
        let tabPanelNodes = [];

        Object.keys(tabs || {}).forEach(tab => {
            let isActive = this.state.activeIdx === Object.keys(tabs || []).indexOf(tab);
            let tabPanel = tabs[tab];
            tabPanelNodes.push(this.renderTabPanel(tab, tabPanel, isActive));
        })

        return tabPanelNodes;
    }

    renderTabPanel(tab, tabPanel, isActive) {
        return (
            <div key={`${this.normalizeTabId(tab)}_content`} id={`${this.normalizeTabId(tab)}_content`} className={`tab-pane ${isActive ? 'active' : ''}`}>
                {tabPanel}
            </div>
        );
    }

    normalizeTabId(tab) {
        return tab.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
    }
}

export default Tabs;